const ArrivalCertKeys = {
  TITLE: "title",
  ID: "id",
  CCN: "ccn",
  ARRIVAL_DATE_TIME: "arrivalDateTime",
  ARRIVAL_TIME_ZONE: "arrivalTimeZone",
  DESTINATION_OFFICE_CODE: "destinationOfficeCode",
  WAREHOUSE_CODE: "warehouseCode",
  MESSAGE_FUNCTION: "messageFunction",
  BUSINESS_NUMBER: "businessNumber",
  STATUS: "status",
  REMARKS: "remarks",
  MODE_OF_SUBMISSION: "modeOfSubmission",
  PARTY_ID: "partyId",
  SUBMITTED_BY: "submittedBy",
  SUBMITTED_DATE: "submittedDate",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  UPDATED_BY: "updatedBy",
  UPDATED_DATE: "updatedDate",
  VERSION: "version",
  RESPONSE_TITLE:"responseTitle",
  BUSINESS_NUM_FLAG:"businessNumFlag",
  SAVE_BUTTON: "saveButton",
  SUBMIT_BUTTON: "submitButton",
  UPDATE_BUTTON: "updateButton",
  CLONE_BUTTON: "cloneButton",
  CLONE_MULTIPLE_BUTTON: "cloneMultipleRecords",
  DELETE_BUTTON: "deleteButton",
  DELETE_MULTIPLE_RECORDS: "deleteMultiple",
  SUBMIT_MULTIPLE_RECORDS: "submitMultiple",
  ERROR: "error",
  SUBMIT_AS_MODIFY:"submitAsModify",
  BOL_NUMBER: "bolNumber",
  EDIT_BUTTON: "editButton",
  EDIT_TOOLTIP_DISABLED: "editTooltipDisabled",
  UPLOAD_BUTTON: "uploadButton",
  CREATE_BUTTON: "createButton",
  SUBMIT_ALL_BUTTON: "submitAllButton",
  SUBMIT_AS_MODIFY_BUTTON: "submitAsModifyButton",
  DELETE_CONFIRM_MESSAGE: "deleteConfirmMessage",
  DELETE_CONFIRM_YES: "deleteConfirmYes",
  DELETE_CONFIRM_NO: "deleteConfirmNo",
  DELETE_SUCCESS_MESSAGE: "deleteSuccessMessage",
  DELETE_PARTIAL_MESSAGE: "deletePartialMessage",
  CLONE_ERROR_MESSAGE: "cloneErrorMessage",
  SUBMIT_SUCCESS_MESSAGE: "submitSuccessMessage",
  SUBMIT_ALL_FAILED_MESSAGE: "submitAllFailedMessage",
  FILTER_MSG_FUNC_ADD: "filterMsgFuncAdd",
  FILTER_MSG_FUNC_CANCEL: "filterMsgFuncCancel",
  FILTER_MSG_FUNC_MODIFY: "filterMsgFuncModify",
  FILTER_STATUS_DRAFT: "filterStatusDraft",
  FILTER_STATUS_SENT: "filterStatusSent",
  FILTER_STATUS_GOODS_RELEASED: "filterStatusGoodsReleased",
  FILTER_STATUS_DECLARATION_ACCEPTED_AWAITING_ARRIVAL: "filterStatusDeclarationAcceptedAwaitingArrival",
  FILTER_STATUS_DECLARATION_ACCEPTED_AWAITING_CUSTOMS: "filterStatusDeclarationAcceptedAwaitingCustoms",
  FILTER_STATUS_MESSAGE_CONTENT_REJECTED: "filterStatusMessageContentRejected",
  FILTER_STATUS_MESSAGE_CONTENT_ACCEPTED: "filterStatusMessageContentAccepted",
  FILTER_STATUS_GOODS_REQUIRED_EXAMINATION: "filterStatusGoodsRequiredExamination",
  FILTER_STATUS_GOODS_MAY_MOVE_DETAIN: "filterStatusGoodsMayMoveDetain",
  FILTER_STATUS_ERROR_MESSAGE: "filterStatusErrorMessage",
  FILTER_STATUS_AUTHORISED_DELIVER_CSA: "filterStatusAuthorisedDeliverCsa",
  FILTER_ERROR_DESC_EDIFACT: "filterErrorDescEdifact",
  Validations:{
    INVALID_ARRIVAL_DATE_TIME_FORMAT:"invalidDateTimeFormat",
    MAX_LENGTH_25:"maxLength25",
    MIN_LENGTH_5:"minLength5",
    ALPHA_NUMERIC_REGX:"alphaNumericReqx"
  }
}

export default ArrivalCertKeys
